import { isHighlightSearchWhitespace } from '../highlightSearchText';
import type { TIndexedSearchText } from './types';

/**
 * Collects text for a quote search: runs of whitespace become one space, every character remembers
 * where it came from, and a trailing space is dropped. What a position is belongs to the caller -
 * a DOM text node and its offsets, or a document range.
 */
export const createSearchTextIndex = <TPosition>() => {
  const text: string[] = [];
  const positions: TPosition[] = [];
  let previousWasWhitespace = false;

  const append = (piece: string, position: TPosition) => {
    text.push(piece);
    for (let index = 0; index < piece.length; index += 1) positions.push(position);
  };

  return {
    add: (char: string, position: TPosition) => {
      if (isHighlightSearchWhitespace(char)) {
        if (text.length > 0 && !previousWasWhitespace) {
          append(' ', position);
          previousWasWhitespace = true;
        }
        return;
      }
      append(char.normalize('NFC').toLowerCase(), position);
      previousWasWhitespace = false;
    },
    /** A gap between two blocks, so words either side do not run together. */
    separate: (position: TPosition) => {
      if (text.length === 0 || previousWasWhitespace) return;
      append(' ', position);
      previousWasWhitespace = true;
    },
    done: (): TIndexedSearchText<TPosition> => {
      while (text.length > 0 && text[text.length - 1] === ' ') {
        text.pop();
        positions.pop();
      }
      return { text: text.join(''), positions };
    },
  };
};
